<template>
  <a href="javascript:void(0);" :class="['novel-tag', tagClass]"><slot>{{title}}</slot></a>
</template>

<script>
export default {
  props: {
    type: String,
    title: String,
  },
  computed: {
    tagClass() {
      if (this.type) return this.type;
      const classNames = ['green', 'yellow', 'red', 'blue', 'purple'];
      const random = Math.floor(Math.random() * classNames.length);
      const type = classNames[random];
      return type;
    },
  },
};
</script>

<style lang="less" scoped>
.novel-tag {
    display: inline-block;
    height: 20px;
    line-height: 20px;
    padding: 0 10px;
    border-radius: 10px;
    font-size: @fontSmall;
    background-color: rgba(232, 249, 232, 1);
    color: rgba(42, 207, 174, 1);
    &.text {
        background-color: #fff;
        color: @gray;
    }
    &.yellow {
        background-color: rgba(255, 244, 207, 1);
        color: rgba(231, 180, 94, 1);
    }
    &.green {
        background-color: rgba(232, 249, 232, 1);
        color: rgba(42, 207, 174, 1);
    }
    &.blue {
        background-color: rgba(223, 231, 255, 1);
        color: rgba(89, 121, 218, 1);
    }
    &.red {
        background-color: rgba(254, 215, 222, 1);
        color: rgba(235, 71, 90, 1);
    }
    &.purple {
        background-color: rgba(240, 214, 251, 1);
        color: rgba(164, 69, 172, 1);
    }
}
</style>
